var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConwxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.02,
    height: 20,
    viewBox: "0 0 68.02 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.13,12.86v1A5.15,5.15,0,0,1,20,19h-1.4a5.06,5.06,0,0,1-3.46-1.34A9,9,0,1,1,11.53,2.26L12.78,0l1.38,3.5L15.5,6.9,14.36,7l-5.63.37L10.24,4.6a5.62,5.62,0,0,0-.92-.07,6.42,6.42,0,1,0,4.42,11.08,5.38,5.38,0,0,1-.31-1.78v-1a5.17,5.17,0,0,1,5.15-5.15H20A5.16,5.16,0,0,1,25.13,12.86Zm-3.59-.62a2.07,2.07,0,0,0-2.07-2.07h-.38a2,2,0,0,0-1,.27A2.06,2.06,0,0,0,17,12.24v2.32a2.25,2.25,0,0,0,.07.52,2.06,2.06,0,0,0,2,1.55h.38a2.07,2.07,0,0,0,2.07-2.07ZM68,4.23H63.69l-3,4.55-3-4.55H51.79l-2.06,9.45L47.34,4.23H43.53L41,14,38.86,4.23h-4l3.86,14.55h4.15l2.52-9.14,2.29,9.14H52l3-11.86L58.3,11.5l-5,7.28h4.19l3.1-4.65,2.86,4.65H68l-5.23-7.43ZM33.67,7.69a5.54,5.54,0,0,0-4.5,1.39V7.93H25.5V18.78h3.67V11.15s3.6-1.91,3.62.73v6.9h3.58v-6.9S36.46,8.08,33.67,7.69Z",
    fill: "#368ed8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConwxLogo);
export default __webpack_public_path__ + "static/media/conwx_logo.1233e849dc0174d1e085fbe067ea644b.svg";
export { ForwardRef as ReactComponent };